import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { BiPencil } from 'react-icons/bi'
import { AuthorizedInteractable } from '@containers/common/auth'
import AccountProfileListGroup from './AccountProfileListGroup'
import { ColumnContainer, ButtonsBar } from '@res/styledComponents/index'

const initialState = {}

export class AccountProfile extends Component {
  state = initialState

  componentDidMount() {
    const { account } = this.props
    this.loadAccountStats(account.id)
    this.loadClientReportingPrograms(account.id)
    this.loadDinerProfiles(account)
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.account &&
      this.props.account &&
      nextProps.account.id !== this.props.account.id
    ) {
      this.setState(initialState, () => {
        this.loadAccountStats(nextProps.account.id)
        this.loadClientReportingPrograms(nextProps.account.id)
        this.loadDinerProfiles(nextProps.account)
      })
    }
  }

  onEditAccount = (e) => {
    e.preventDefault()

    this.props.editAccount()
  }

  loadAccountStats = async (accountId) => {
    const stats = await this.props.loadAccountStats(accountId)
    if (stats) {
      this.setState({ stats })
    }
  }

  loadClientReportingPrograms = async (accountId) => {
    const { loadClientReportingPrograms } = this.props

    await loadClientReportingPrograms({ clientId: accountId })
  }

  loadDinerProfiles = async (account) => {
    const { loadDinerProfiles } = this.props
    const { id, contacts, addresses } = account

    await loadDinerProfiles(id, contacts, addresses)
  }

  onEditClientReportingProgram = (program) => {
    const { editClientReportingProgram } = this.props
    editClientReportingProgram(program)
  }

  onEditDinerProfile = (dinerProfile) => {
    const { editDinerProfile } = this.props
    editDinerProfile(dinerProfile)
  }

  onMarkDefaultDinerProfile = async (profileId) => {
    const { markDefaultDinerProfile, account, currentUser } = this.props

    const updatedBy = `${currentUser.firstName} ${currentUser.lastName}`

    await markDefaultDinerProfile(
      account.id,
      profileId,
      updatedBy,
      account.contacts,
      account.addresses,
    )
  }

  onMarkDefaultAccountContact = async (contactId) => {
    const {
      account: { id, accountContacts },
      markDefaultAccountContact,
    } = this.props

    const accountContact = accountContacts.find(
      (c) => c.contactId === contactId,
    )
    if (accountContact) {
      await markDefaultAccountContact(id, accountContact.id)
    }
  }

  onMarkDefaultAccountAddress = async (addressId) => {
    const {
      account: { id, addresses },
      markDefaultAccountAddress,
    } = this.props

    const address = addresses.find((a) => a.id === addressId)
    if (address) {
      await markDefaultAccountAddress(id, address.id)
    }
  }

  onDeleteAccountContact = async (accountContact) => {
    if (!accountContact) {
      return
    }

    const { account, dinerProfiles, host } = this.props
    await this.props.deleteAccountContact(
      account.id,
      accountContact,
      dinerProfiles,
      host,
    )
  }

  onDeleteAccountAddress = async (address) => {
    const { account, dinerProfiles, host } = this.props

    await this.props.deleteAccountAddress(
      account.id,
      address,
      dinerProfiles,
      host,
    )
  }

  render() {
    const { account, dinerProfiles, clientReportingPrograms } = this.props
    const { stats } = this.state

    return (
      <div>
        <ButtonsBar>
          <AuthorizedInteractable
            roles={['master admin', 'sales rep', 'sales lead']}
          >
            <button onClick={this.onEditAccount}>
              <BiPencil />
              Edit
            </button>
          </AuthorizedInteractable>
        </ButtonsBar>
        <ColumnContainer>
          <AccountProfileListGroup
            accountProfile={{
              ...stats,
              ...account,
              dinerProfiles,
              clientReportingPrograms,
            }}
            onEditAccount={this.onEditAccount}
            onEditClientReportingProgram={this.onEditClientReportingProgram}
            onEditDinerProfile={this.onEditDinerProfile}
            onMarkDefaultDinerProfile={this.onMarkDefaultDinerProfile}
            onMarkDefaultContact={this.onMarkDefaultAccountContact}
            onMarkDefaultAddress={this.onMarkDefaultAccountAddress}
            onDeleteAccountContact={this.onDeleteAccountContact}
            onDeleteAccountAddress={this.onDeleteAccountAddress}
          />
        </ColumnContainer>
      </div>
    )
  }
}

AccountProfile.propTypes = {
  account: PropTypes.object,
  clientReportingPrograms: PropTypes.array,
  currentUser: PropTypes.object,
  dinerProfiles: PropTypes.array,
  host: PropTypes.string,

  editAccount: PropTypes.func,
  loadAccountStats: PropTypes.func,
  loadDinerProfiles: PropTypes.func,
  loadClientReportingPrograms: PropTypes.func,
  editClientReportingProgram: PropTypes.func,
  editDinerProfile: PropTypes.func,
  markDefaultDinerProfile: PropTypes.func,
  markDefaultAccountContact: PropTypes.func,
  markDefaultAccountAddress: PropTypes.func,
  deleteAccountContact: PropTypes.func,
  deleteAccountAddress: PropTypes.func,
}

export default AccountProfile
